var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-form-group",
        {
          attrs: {
            label: "License designation",
            state: _vm.designationState,
            "invalid-feedback": _vm.designationFeedback,
            description:
              "Required for a new license. Medical, Adult Use, or both for a dual license.",
          },
        },
        [
          _c("b-form-checkbox-group", {
            attrs: {
              checked: _vm.value.designation,
              options: _vm.designations,
              state: _vm.designationState,
              name: "manual-designation",
            },
            on: {
              input: function ($event) {
                return _vm.update("designation", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-form-group",
        {
          attrs: {
            label: "Business activity",
            state: _vm.activityState,
            "invalid-feedback": _vm.activityFeedback,
            description:
              "Required for a new license. Retail browse lists only licenses with Retailer. Operator does not mean Retailer.",
          },
        },
        [
          _c("b-form-checkbox-group", {
            attrs: {
              checked: _vm.value.business_types,
              options: _vm.activities,
              state: _vm.activityState,
              name: "manual-business-types",
            },
            on: {
              input: function ($event) {
                return _vm.update("business_types", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }